<template>
    <div>
        <base-modal :id="String(_uid)" :centered="true" :loading="loading">
            <template slot="title">
                <span class="align-middle">Clone to Library</span>
            </template>
            <template>
                <div class="my-2">
                    <p>Select a workspace to clone this learning experience to:</p>
                    <v-select
                        v-model="selectedMembership"
                        :options="authorMemberships"
                        :close-on-select="true"
                        :getOptionLabel="(option) => option.organization.name"
                        class="mw-100"
                        placeholder="Select a workspace..."
                    >
                        <template slot="option" slot-scope="option">
                            <span class="medium align-middle mr-2">{{ option.organization.name }}</span>
                            <span class="align-middle badge badge-tiny badge-gray">{{
                                displayRoleName(option.role)
                            }}</span>
                        </template>
                        <template v-slot:selected-option="option">
                            <span class="medium align-middle mr-2">{{ option.organization.name }}</span>
                            <span class="align-middle badge badge-tiny badge-gray">{{
                                displayRoleName(option.role)
                            }}</span>
                        </template>
                        <template slot="no-options">
                            <div class="py-2">
                                <span class="text-secondary">You don't have access to any workspaces.</span>
                            </div>
                        </template>
                    </v-select>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-gray" type="button" data-dismiss="modal">Close</button>
                <button class="btn btn-brand" type="button" :disabled="submitDisabled" @click="submit()">
                    <span class="icon icon-glyphicons-basic-squares icon-mr align-middle"></span>
                    <span class="align-middle">Clone to Library</span>
                </button>
            </template>
        </base-modal>
    </div>
</template>
    
<script>
import http from "@/axios.js"
import BaseModal from "@/components/BaseModal"
import { roleNames } from "@/assets/js/settings.js"

export default {
    name: "CommunityAddModal",
    components: {
        BaseModal,
    },
    props: {
        caseObj: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedMembership: null,
            loading: false,
        }
    },
    computed: {
        hasOrgMemberships() {
            return this.$store.getters.memberships.length > 0
        },
        authorMemberships() {
            return this.$store.getters.memberships.filter((membership) => {
                return ["admin", "author"].includes(membership.role)
            })
        },
        hasAuthorMemberships() {
            return this.authorMemberships.length > 0
        },
        submitDisabled() {
            return this.loading || !this.selectedMembership
        },
        activeMembership() {
            return this.$store.getters.activeMembership
        },
    },
    methods: {
        open() {
            if (!this.hasAuthorMemberships) {
                // This is a temporary hack - open the create-organization modal, which lives
                // in the TopNav component. This workflow needs to be improved.
                $("#create-first-organization-modal").modal("show")
                return
            }
            $("#" + this._uid).modal("show")
            if (this.activeMembership) {
                this.selectedMembership = this.activeMembership
            }
        },
        displayRoleName(roleCode) {
            let roleName = roleNames[roleCode]
            if (!roleName) {
                // Fallback to the role code.
                return roleCode
            }
            return roleName
        },
        submit() {
            this.loading = true
            let organization = this.selectedMembership.organization
            let vm = this
            http.post(`/api/community/cases/${this.caseObj.id}/clone-to-library/`, {
                organizationId: organization.id,
                parent_item_id: this.$route.query.addToParent,
            })
                .then(function () {
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Content cloned to library.",
                        data: {},
                    })
                    vm.$emit("added-to-library", organization)
                    $("#" + vm._uid).modal("hide")
                })
                .finally(() => {
                    vm.loading = false
                })
        },
    },
}
</script>
